module.exports = __webpack_public_path__ + "img/logo-loading.61841037.png";